import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { BASE_URL } from '../config/api'; // Ensure BASE_URL is correctly defined

const EditProcessPosOrder = () => {
    const { id } = useParams(); // Get the order id from URL
    const [orderData, setOrderData] = useState({
        sno: 1,
        order_no: '',
        order_date: '',
        name: '',
        last_name: '',
        email: '',
        phone: '',
        city: '',
        state: '',
        item_code: '',
        quantity: 0,
        rate: 0,
        amount: 0,
        discount: 0,
        billing_address: '',
        shipping_address: '',
        payment: '',
        cancel_reason: '',
        tax_inclusive: true,
        total_discount: 0,
        shipping: 0,
        item_name: '',
        currency: 'USD',
    });

    const navigate = useNavigate();

    // Fetch order data on component mount
    useEffect(() => {
        fetch(`${BASE_URL}processposorders/${id}`)
            .then((response) => response.json())
            .then((data) => {
                if (data.status === 'success') {
                    setOrderData(data.data);
                } else {
                    alert('Failed to fetch order details');
                }
            })
            .catch((error) => {
                console.error('Error fetching order:', error);
                alert('An error occurred while fetching order details.');
            });
    }, [id]);

    // Handle form input changes
    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setOrderData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    // Handle form submission to update the order
    const handleSubmit = (event) => {
        event.preventDefault();

        // Send PUT request to update the order
        fetch(`${BASE_URL}processposorders/${id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(orderData),
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.status === 'success') {
                    alert('Order updated successfully!');
                    navigate('/ProcessPosOrdersList'); // Navigate to the orders list after successful update
                } else {
                    alert('Failed to update order. Please try again.');
                }
            })
            .catch((error) => {
                console.error('Error updating order:', error);
                alert('An error occurred. Please try again.');
            });
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Edit Process POS Order</h3>
                        </div>
                    </div>
                </div>
            </div>

            {/* Edit Order Form start */}
            <section className="section">
                <div className="row" id="edit-order-form">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <div className="row">
                                    <div className="col-md-6">
                                        <h4>Edit Order Details</h4>
                                    </div>
                                    <div className="col-md-6 text-end">
                                        <button
                                            className="btn btn-primary"
                                            onClick={() => navigate('/processposorders')}
                                        >
                                            Back to Orders List
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="order_no" className="form-label">
                                            Order No
                                        </label>
                                        <input
                                            type="text"
                                            id="order_no"
                                            name="order_no"
                                            className="form-control"
                                            value={orderData.order_no}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="order_date" className="form-label">
                                            Order Date
                                        </label>
                                        <input
                                            type="date"
                                            id="order_date"
                                            name="order_date"
                                            className="form-control"
                                            value={orderData.order_date}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="name" className="form-label">
                                            Customer Name
                                        </label>
                                        <input
                                            type="text"
                                            id="name"
                                            name="name"
                                            className="form-control"
                                            value={orderData.name}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="last_name" className="form-label">
                                            Last Name
                                        </label>
                                        <input
                                            type="text"
                                            id="last_name"
                                            name="last_name"
                                            className="form-control"
                                            value={orderData.last_name}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="email" className="form-label">
                                            Email
                                        </label>
                                        <input
                                            type="email"
                                            id="email"
                                            name="email"
                                            className="form-control"
                                            value={orderData.email}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="phone" className="form-label">
                                            Phone
                                        </label>
                                        <input
                                            type="tel"
                                            id="phone"
                                            name="phone"
                                            className="form-control"
                                            value={orderData.phone}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="city" className="form-label">
                                            City
                                        </label>
                                        <input
                                            type="text"
                                            id="city"
                                            name="city"
                                            className="form-control"
                                            value={orderData.city}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="state" className="form-label">
                                            State
                                        </label>
                                        <input
                                            type="text"
                                            id="state"
                                            name="state"
                                            className="form-control"
                                            value={orderData.state}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="item_code" className="form-label">
                                            Item Code
                                        </label>
                                        <input
                                            type="text"
                                            id="item_code"
                                            name="item_code"
                                            className="form-control"
                                            value={orderData.item_code}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="quantity" className="form-label">
                                            Quantity
                                        </label>
                                        <input
                                            type="number"
                                            id="quantity"
                                            name="quantity"
                                            className="form-control"
                                            value={orderData.quantity}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="rate" className="form-label">
                                            Rate
                                        </label>
                                        <input
                                            type="number"
                                            id="rate"
                                            name="rate"
                                            className="form-control"
                                            value={orderData.rate}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="amount" className="form-label">
                                            Amount
                                        </label>
                                        <input
                                            type="number"
                                            id="amount"
                                            name="amount"
                                            className="form-control"
                                            value={orderData.amount}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="discount" className="form-label">
                                            Discount
                                        </label>
                                        <input
                                            type="number"
                                            id="discount"
                                            name="discount"
                                            className="form-control"
                                            value={orderData.discount}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="billing_address" className="form-label">
                                            Billing Address
                                        </label>
                                        <input
                                            type="text"
                                            id="billing_address"
                                            name="billing_address"
                                            className="form-control"
                                            value={orderData.billing_address}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="shipping_address" className="form-label">
                                            Shipping Address
                                        </label>
                                        <input
                                            type="text"
                                            id="shipping_address"
                                            name="shipping_address"
                                            className="form-control"
                                            value={orderData.shipping_address}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="payment" className="form-label">
                                            Payment Method
                                        </label>
                                        <select
                                            id="payment"
                                            name="payment"
                                            className="form-select"
                                            value={orderData.payment}
                                            onChange={handleInputChange}
                                        >
                                            <option value="Credit Card">Credit Card</option>
                                            <option value="Debit Card">Debit Card</option>
                                            <option value="Cash">Cash</option>
                                        </select>
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="cancel_reason" className="form-label">
                                            Cancel Reason
                                        </label>
                                        <input
                                            type="text"
                                            id="cancel_reason"
                                            name="cancel_reason"
                                            className="form-control"
                                            value={orderData.cancel_reason}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="tax_inclusive" className="form-label">
                                            Tax Inclusive
                                        </label>
                                        <select
                                            id="tax_inclusive"
                                            name="tax_inclusive"
                                            className="form-select"
                                            value={orderData.tax_inclusive}
                                            onChange={handleInputChange}
                                        >
                                            <option value={true}>Yes</option>
                                            <option value={false}>No</option>
                                        </select>
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="total_discount" className="form-label">
                                            Total Discount
                                        </label>
                                        <input
                                            type="number"
                                            id="total_discount"
                                            name="total_discount"
                                            className="form-control"
                                            value={orderData.total_discount}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="shipping" className="form-label">
                                            Shipping Fee
                                        </label>
                                        <input
                                            type="number"
                                            id="shipping"
                                            name="shipping"
                                            className="form-control"
                                            value={orderData.shipping}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="item_name" className="form-label">
                                            Item Name
                                        </label>
                                        <input
                                            type="text"
                                            id="item_name"
                                            name="item_name"
                                            className="form-control"
                                            value={orderData.item_name}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="currency" className="form-label">
                                            Currency
                                        </label>
                                        <input
                                            type="text"
                                            id="currency"
                                            name="currency"
                                            className="form-control"
                                            value={orderData.currency}
                                            onChange={handleInputChange}
                                        />
                                    </div>

                                    <button type="submit" className="btn btn-primary">
                                        Save Changes
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Edit Order Form end */}
        </div>
    );
};

export default EditProcessPosOrder;
